import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getGame } from "../../extensions/gamemode_management/util/getGame";
import { useWindowContext } from "../../contexts";
import FlexLayout from "../../controls/FlexLayout";
import Icon from "../../controls/Icon";
import { Button } from "../../controls/TooltipControls";
import { activeProfile as activeProfileSelector, mainPage as mainPageSelector, secondaryPage as secondaryPageSelector, } from "../../util/selectors";
import { MainFooter } from "../MainFooter";
import { PageGroup } from "./PageGroup";
/**
 * Provides the sidebar component.
 * For Classic layout.
 */
export const Sidebar = (props) => {
    const { pages, onClickPage, onToggleMenu, onSidebarRef } = props;
    const { t } = useTranslation();
    const { menuIsCollapsed } = useWindowContext();
    const mainPage = useSelector(mainPageSelector);
    const secondaryPage = useSelector(secondaryPageSelector);
    const profile = useSelector(activeProfileSelector);
    const pageGroups = useMemo(() => {
        const game = profile !== undefined ? getGame(profile.gameId) : undefined;
        const gameName = game?.shortName || game?.name || "Mods";
        return [
            { title: undefined, key: "dashboard" },
            { title: "General", key: "global" },
            { title: gameName, key: "per-game" },
            { title: "About", key: "support" },
        ];
    }, [profile]);
    const sbClass = menuIsCollapsed ? "sidebar-compact" : "sidebar-expanded";
    return (React.createElement(FlexLayout.Fixed, { className: sbClass, id: "main-nav-sidebar" },
        React.createElement("div", { id: "main-nav-container", ref: onSidebarRef }, pageGroups.map(({ title, key }) => {
            const groupPages = pages.filter((page) => page.group === key);
            return (React.createElement(PageGroup, { groupKey: key, key: key, mainPage: mainPage, pages: groupPages, secondaryPage: secondaryPage, tabsMinimized: menuIsCollapsed, title: title, onClickPage: onClickPage }));
        })),
        React.createElement(MainFooter, { slim: menuIsCollapsed }),
        React.createElement(Button, { className: "btn-menu-minimize", id: "btn-minimize-menu", tooltip: menuIsCollapsed ? t("Restore") : t("Minimize"), onClick: onToggleMenu },
            React.createElement(Icon, { name: menuIsCollapsed ? "pane-right" : "pane-left" }))));
};
